// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"pbrRating__gradient-bg5__RnR65"};